<template>
  <balance
      :title="title"
      :cols="(isXs)?mobileCols:datatableCols"
      url="reports/balance"
      :getAccountLedgerQuery="getAccountLedgerQuery"
      :getSubAccountLedgerQuery="getSubAccountLedgerQuery"
      :defaultFilters="defaultFilters"
      :contrary-to-nature="true"
      ref="balance"
  />
</template>

<script>
import datatableCols from "./_datatableCols";
import Balance from "../Balance";

export default {
  name: "ContraryToNatureAccountsBalance",
  components: {Balance},
  data() {
    return {
      datatableCols,
      defaultFilters: {
        level: 3,
        account_type: null,
        cols_count: 4,
        show_differences: true,
        balance_status: "with_remain",
      },
      mobileCols: {
        cols: [
          {
            text: "نام حساب",
            value: "name",
          },
        ],
      }

    };
  },
  methods: {
    getAccountLedgerQuery(item) {
      return {
        "ledger.account": item.id,
        "ledger.level": `level${item.level}`,
      };
    },
    getSubAccountLedgerQuery(item, subAccount) {
      return {
        "ledger.account": item.id,
        "ledger.floatAccount": subAccount.level == "floatAccounts" ? subAccount.id : null,
        "ledger.level": `level${item.level}`,
      };
    },
  },
  computed: {
    title() {
      return this.setDocumentTitle('گزارش حسابهای خلاف ماهیت')
    },
  }
  };
</script>
